import React, { Component } from 'react'
import '../card.css'
import { setYaprakSekli } from '../../../../store/actions/resultInfo'
import { connect } from 'react-redux'

class Card extends Component {

    async handleClick() {
        await setYaprakSekli(this.props.typeText)
        this.props.history.push(`resultTree?t=${this.props.resultInfo.mainType}&ac=${this.props.resultInfo.agacCali}&yt=${this.props.resultInfo.yaprakTipi}&ys=${this.props.typeText}
        `)
    }

    render() {
        return (
            <div onClick={() => this.handleClick()} class="card-outer-container result-card-outer-container">
                <div class="card-inner-container type-card-inner-container">
                    <div class="card-image-container">
                        <img class="type-card-image" src={this.props.image} alt={this.props.typeText + " image"} />
                    </div>
                    <div class="card-text-container">
                        <p class="card-text" style={{ whiteSpace: "pre-line" }}>{this.props.typeText}</p>
                    </div>
                </div>
            </div>
        )
    }
}

export default connect((store) => ({ resultInfo: store.resultInfo }), {})(Card)
